export default {
  title: 'Notificări push',
  description: 'Trimiteți notificări push direcționate clienților dvs.',
  buttons: {
    new_campaign: 'Campanie nouă',
  },
  error_messages: {
    no_mobile_app: {
      title: 'Aplicația mobilă nu este încă activă',
      description: 'Așteptați ca aplicația mobilă să fie activă înainte de a trimite notificări push',
    },
  },
};
